import { createReducer, on } from '@ngrx/store';

import { TechnicalResultState } from '../../models/technical-result.model';
import * as TechnicalResultActions from '../actions/technical-result.actions';

export const intialState: TechnicalResultState = {
  technicalResult: null,
};

export const companyStructureReducer = createReducer<TechnicalResultState>(
  intialState,
  on(TechnicalResultActions.loadTechnicalResultSuccess, (state, { technicalResult }) => ({
    ...state,
    technicalResult,
  })),
);
